import React from 'react';
import PropTypes from 'prop-types';
import IfComponent from '../IfComponent';

class DropdownMenu extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    button: PropTypes.node,
    className: PropTypes.string,
    onBlur: PropTypes.func,
    tabIndex: PropTypes.number,
    disabled: PropTypes.bool,
    ariaLabel: PropTypes.string,
    ariaControls: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    button: null,
    className: 'tv-filter-list__element',
    onBlur: () => {},
    tabIndex: 0,
    disabled: false,
    ariaLabel: '',
    ariaControls: '',
  };

  constructor(props) {
    super(props);
    this.state = { showMenu: false };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onEscapePress);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscapePress);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  onEscapePress = e => {
    if (e.key === 'Escape' && this.state.showMenu) {
      this.setState({
        showMenu: false,
      });
    }
  };

  onHiddenMenu = () => {
    this.setState({
      showMenu: false,
    });
  };

  handleClickOutside = event => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ showMenu: false });
    }
  };

  onToggleMenu = () => {
    if (this.toggleTimeout) {
      window.clearTimeout(this.toggleTimeout);
    }
    this.toggleTimeout = window.setTimeout(() => {
      this.setState(prevState => ({ showMenu: !prevState.showMenu }));
    }, 200);
  };

  onBlur = event => {
    const { currentTarget } = event;
    window.setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        this.setState({ showMenu: false });
      }
    }, 250);
    const { onBlur } = this.props;
    onBlur();
  };

  render() {
    const { showMenu } = this.state;
    const {
      children,
      button,
      className,
      disabled,
      tabIndex,
      ariaLabel,
      ariaControls,
    } = this.props;

    return (
      <span ref={this.dropdownRef} onBlur={this.onBlur} className={className}>
        <div
          role="button"
          tabIndex={tabIndex}
          onClick={disabled ? null : this.onToggleMenu}
          onKeyPress={e => {
            if (disabled) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.onToggleMenu();
            }
          }}
          className="tv-form__element-focus dropdown-button"
        >
          {button}
        </div>
        <IfComponent condition={showMenu} whenTrue={children} />
      </span>
    );
  }
}

export default DropdownMenu;
